var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2727_297",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V45H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2727_297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2031 15.248V3.38281C11.2031 1.92664 12.3837 0.746092 13.8398 0.746092H41.7012C43.1573 0.746092 44.3379 1.92664 44.3379 3.38281V27.1133L39.0645 21.8398H33.791",
    fill: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2031 15.248V3.38281C11.2031 1.92664 12.3837 0.746092 13.8398 0.746092H41.7012C43.1573 0.746092 44.3379 1.92664 44.3379 3.38281V27.1133L39.0645 21.8398H33.791",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0703 11.3184C32.0703 10.5903 32.6606 10 33.3887 10C34.1168 10 34.707 10.5903 34.707 11.3184C34.707 12.0464 34.1168 12.6367 33.3887 12.6367C32.6606 12.6367 32.0703 12.0464 32.0703 11.3184Z",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7969 11.3184C26.7969 10.5903 27.3871 10 28.1152 10C28.8433 10 29.4336 10.5903 29.4336 11.3184C29.4336 12.0464 28.8433 12.6367 28.1152 12.6367C27.3871 12.6367 26.7969 12.0464 26.7969 11.3184Z",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5234 11.3184C21.5234 10.5903 22.1137 10 22.8418 10C23.5699 10 24.1602 10.5903 24.1602 11.3184C24.1602 12.0464 23.5699 12.6367 22.8418 12.6367C22.1137 12.6367 21.5234 12.0464 21.5234 11.3184Z",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1348 36.3672V20.5469C34.1348 19.0907 32.9542 17.9102 31.498 17.9102H3.63672C2.18055 17.9102 1 19.0907 1 20.5469V44.2773L6.27344 39.0039H31.498C32.9542 39.0039 34.1348 37.8234 34.1348 36.3672Z",
    fill: "url(#paint0_linear_2727_297)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6133 28.457C13.6133 27.7289 13.023 27.1387 12.2949 27.1387C11.5668 27.1387 10.9766 27.7289 10.9766 28.457C10.9766 29.1851 11.5668 29.7754 12.2949 29.7754C13.023 29.7754 13.6133 29.1851 13.6133 28.457Z",
    fill: "white",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8867 28.457C18.8867 27.7289 18.2964 27.1387 17.5684 27.1387C16.8403 27.1387 16.25 27.7289 16.25 28.457C16.25 29.1851 16.8403 29.7754 17.5684 29.7754C18.2964 29.7754 18.8867 29.1851 18.8867 28.457Z",
    fill: "white",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1602 28.457C24.1602 27.7289 23.5699 27.1387 22.8418 27.1387C22.1137 27.1387 21.5234 27.7289 21.5234 28.457C21.5234 29.1851 22.1137 29.7754 22.8418 29.7754C23.5699 29.7754 24.1602 29.1851 24.1602 28.457Z",
    fill: "white",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_297",
    x1: 2.84375,
    y1: 19.5254,
    x2: 35.4886,
    y2: 31.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130893,
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUs.7d9c3fc2fa2ecfde6c0bdffa403f3ec3.svg";
export { ForwardRef as ReactComponent };